import script from "./LoginPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginPopup.vue?vue&type=script&setup=true&lang=js"

import "./LoginPopup.vue?vue&type=style&index=0&id=acab6d20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acab6d20"]])

export default __exports__